import type { EvidenceRow } from '../v4/contracts'

/** A value with its unit; a yes-or-no verdict has no unit. Ported from the v4 answer panel. */
export function valueText(e: EvidenceRow, missing: string): string {
  if (e.value === undefined || e.value === null) return missing
  if (typeof e.value === 'boolean') return e.value ? 'yes' : 'no'
  return `${String(e.value)}${e.unit ? ` ${e.unit}` : ''}`
}
